import {
  Chart,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartSeries,
  ChartSeriesItem,
} from '@progress/kendo-react-charts';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useMount from '../../../../../../common/hooks/useMount';
import { MostOrderedProductsItemModel } from '../../../../models/analytics';
import { resources } from '../../../../resources/resources';
import { analyticsService } from '../../../../services/analytics';
import { formatLabel } from '../utils';

export const MostOrderedProductsChart = () => {
  const [mostOrderedProducts, setMostOrderedProducts] = useState<
    MostOrderedProductsItemModel[]
  >([]);
  const { t: translate } = useTranslation();

  const loadMostOrderedProducts = async (abortController?: AbortController) => {
    const resp = await analyticsService.getMostOrderedProducts({
      signal: abortController?.signal,
    });
    if (abortController?.signal.aborted) return;
    if (!resp.hasErrors) {
      setMostOrderedProducts(resp.data);
    }
  };

  useMount(loadMostOrderedProducts);

  return (
    <div className="m-panel m-analytics-panel">
      <h2>{translate(resources.analytics.charts.mostOrdered)}</h2>
      <Chart style={{ height: 300 }} transitions={false}>
        <ChartSeries>
          <ChartSeriesItem
            type="column"
            color="#ff220d"
            tooltip={{
              visible: true,
            }}
            data={mostOrderedProducts}
            field="value"
            categoryField="name"
          />
        </ChartSeries>
        <ChartCategoryAxis>
          <ChartCategoryAxisItem
            majorGridLines={{ visible: false }}
            labels={{
              content: e => formatLabel(e.value, 6),
            }}
          ></ChartCategoryAxisItem>
        </ChartCategoryAxis>
      </Chart>
    </div>
  );
};
